<div class="modal-content border-0 rounded-4 shadow-lg position-relative" style="overflow: visible;">
  <!-- Overlapping Tick Icon -->
  <div class="position-absolute start-50 translate-middle-x" style="top: -30px; z-index: 1051;">
    <div class="d-flex align-items-center justify-content-center bg-white rounded-circle shadow-sm" style="width: 60px; height: 60px; padding: 4px; border: 1px solid #e9ecef;">
      <div class="d-flex align-items-center justify-content-center rounded-circle" style="width: 60px; height: 60px; background-color: #e8f5ec;">
        <div class="d-flex align-items-center justify-content-center text-white rounded-circle" style="width: 42px; height: 42px; background-color: #13804c;">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
        </div>
      </div>
    </div>
  </div>
  
  <div class="modal-body text-center pt-4">
    <h3 class="fw-bold mb-2 text-dark mt-2" style="font-size: 20px;">{{ title }}</h3>
    <hr class="text-muted opacity-25 my-3">
    <p class="text-secondary text-break mb-4" style="font-size: 15px; line-height: 1.6; font-weight: 500;">
      {{ message }}
    </p>
    <div class="d-flex justify-content-end pt-2">
      <button type="button" class="btn app-btn-primary fw-semibold" (click)="activeModal.close('Done')">
        Done
      </button>
    </div>
  </div>
</div>
